// extracted by mini-css-extract-plugin
export default {"dropDownAction":"TableDropdown_dropDownAction_haLDC","spinAround":"TableDropdown_spinAround_ddGeA"};